(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener( 'DOMContentLoaded', function() {
      var miniSlide = new Splide( '.splide', {
        type   : 'loop',
        autoplay: true,
        perPage: 1,
        heightRatio: .56
      } );
      miniSlide.mount();
  });

  } catch(e) { console.error(e); }
})();
})();
